import { useTranslation } from "@/i18n/client";
import { Box } from "@mantine/core";
import { Modal } from "@/components/Modal";
import ButtonsGroup from "@/components/ButtonsGroup";
import { ContextModalProps } from "@mantine/modals";
import { useSaveMutation } from "@/hooks/useSaveMutation";
import { useRouter } from "next/navigation";
import { useContractState } from "@/hooks/useContractState";

const rightButtonProps = { type: "submit" } as const;

interface CodeSecondaryRequiredModalProps {
  uuid: string;
}

export const codeSecondaryRequiredModalContext = {
  modal: "codeSecondaryRequired",
  closeOnClickOutside: false,
  closeOnEscape: false,
  withCloseButton: false,
  innerProps: {},
};

export const CodeSecondaryRequiredModal = ({ context, id }: ContextModalProps<CodeSecondaryRequiredModalProps>) => {
  const { t } = useTranslation("modals");

  const router = useRouter();
  const { contract, uuid } = useContractState();

  const handleSubmit = () => {
    mutation.mutate({
      ...contract,
      saveDoubleMeasurement: true,
    });
  };

  const handleSuccess = () => router.push("https://www.eon.cz/");

  const mutation = useSaveMutation(uuid, handleSuccess);

  return (
    <Box pos="relative">
      <Modal.LoadingOverlay isLoading={mutation.isPending} />
      <Modal.Title>{t("codeSecondaryRequired.title")}</Modal.Title>
      <Modal.Description description={t("codeSecondaryRequired.description")} />
      <ButtonsGroup
        rightButtonText={t("codeSecondaryRequired.save")}
        onRightButtonClick={handleSubmit}
        rightButtonProps={rightButtonProps}
        withLeftButton={false}
      />
    </Box>
  );
};
